import { PagesTypes } from 'app/utils/createUrl';
import { Box, Flex, Section, Typography } from 'components';
import Submenu from 'components/submenu';

interface HeaderPerfilProps {
  areaIndex: number;
  onAreaClick: (page: PagesTypes) => void;
}

const HeaderPerfil = ({ areaIndex, onAreaClick }: HeaderPerfilProps) => {
  const headerPages: PagesTypes[] = ['account', 'myCourses', 'account/certificates', 'changePassword'];
  // const headerPages: PagesTypes[] = ['account', 'myCourses', 'account/certificates', 'changePassword', 'account/documents', 'account/support'];
  return (
    <>
      <Flex flexGrow={0} bg="navbarBg">
        <Section flexDirection={{ m: 'column', d: 'row' }} justifyContent="space-between">
          <Flex flexGrow={0} flexDirection="column" pt={{ m: 40, d: 40 }} pb={{ m: 60, d: 100 }}>
            <Box position="relative">
              <Typography type="type5" color="primary_400" fontWeight="bold" upper>
                Meu
              </Typography>
            </Box>

            <Typography type="type11" color="white" fontWeight="bold" mt={2}>
              Perfil de Aluno
            </Typography>
          </Flex>

          <Flex width={{ d: 420 }} ml={{ d: 60 }} flexShrink={0} flexGrow={0} />
        </Section>
      </Flex>
      <Submenu
        areas={['Meus dados', 'Meus cursos', 'Notas e certificados', 'Segurança e senha']}
        areaIndex={areaIndex}
        onAreaClick={(index) => onAreaClick(headerPages[index])}
      />
    </>
  );
};

export default HeaderPerfil;
